// Package imports
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { findIndex } from "lodash";
import SearchIcon from "@mui/icons-material/Search";

// Custom imports
//import Confirmation from "../Modal/Confirmation";
import ModuleCard from "../Card/ModuleCard";
import { fetchProduct } from "../../Store/Slices/ProductSlice";
import { twoDigit } from "../../Js/TimeAndDate";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { Button, IconButton, Typography } from "@mui/material";
import { taskSliceActions } from "../../Store/Slices/TaskSlice";
import { productSliceActions } from "../../Store/Slices/ProductSlice";

// Global variables

// Component
const Root = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();

  // State
  const [product, setProduct] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [alertFlag, setAlertFlag] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [module, setModule] = useState({});
  const [dropDownId, setDropDownId] = useState(0);

  // Redux state
  let productId = useSelector(
    (state) => state.defs.siteConfig.products[0]["productId"]
  );
  let productVersion = useSelector(
    (state) => state.defs.siteConfig.products[0]["productVersion"]
  );
  let productName = useSelector(
    (state) => state.defs.siteConfig.products[0]["productName"]
  );

  let coursePermissions = useSelector(
    (state) => state.defs.siteConfig.products[0]["coursePermissions"]
  );
  let { productData, language } = useSelector((state) => state.product);

  const { durationStartTimeStamp } = useSelector((state) => state.task);

  useEffect(() => {
    if (!durationStartTimeStamp && location.pathname.includes("Task")) {
      dispatch(taskSliceActions.setDurationFlag(true));
      dispatch(taskSliceActions.startDuration());
    }
  }, [durationStartTimeStamp]);

  useEffect(() => {
    if (product && product[language]) {
      let foundIndex = findIndex(languages, { id: product[language]["id"] });
      if (foundIndex > -1) {
        setDropDownId(foundIndex);
      }
    }
  }, [language, product]);

  // React logic hooks
  useEffect(() => {
    //if (isFocused) {
    dispatch(commonSliceActions.setLoader(true));
    const innerFun = async () => {
      dispatch(
        fetchProduct({
          productId: productId,
          productVersion: productVersion,
        })
      );
      dispatch(commonSliceActions.setBreadcrumb(null));
    };
    innerFun();
    //}
  }, []);

  useEffect(() => {
    console.log("productData", productData);
    let data = productData;
    if (data) {
      dispatch(commonSliceActions.setLoader(false));
      if (typeof data == "string") {
        data = JSON.parse(data);
      }
      let courseObj;
      if (typeof data[0]["course_data"] == "string") {
        courseObj = JSON.parse(data[0]["course_data"]);
      } else {
        courseObj = product[0]["course_data"];
      }
      setProduct(courseObj["data"][0]["data"]);
      console.log("IIII", courseObj["data"][0]["data"]);
      if (!courseObj.data[0]?.data[0]?.data[0]?.data[0]?.data[0].isClass) {
        setLanguages(
          courseObj["data"][0]["data"].filter((val) => {
            return coursePermissions.indexOf(val.value) == -1;
          })
        );
        if (language == -1) {
          setModule(courseObj["data"][0]["data"][0]["data"]);
          dispatch(productSliceActions.setLanguage(0));
        } else {
          setModule(courseObj["data"][0]["data"][language]["data"]);
        }
      } else {
        setModule(courseObj["data"][0]["data"]);
      }
      setIsLoading(false);
    } else {
      if (location.pathname.includes("CourseConfig")) {
        dispatch(commonSliceActions.setLoader(false));
      }
    }
  }, [productData, coursePermissions]);

  // Route redirect function
  const redirect = (obj) => {
    console.log(location.pathname);
    if (obj.data.length == 0) {
      setAlertFlag(true);
      return false;
    }

    if (location.pathname.includes("Teach")) {
      navigation(`/Teach/Session/${obj.id}`);
    } else if (location.pathname.includes("Task")) {
      if (location.pathname.includes("Create")) {
        navigation(`/Task/Create/Session/${obj.id}`);
      } else {
        navigation(`/Task/Edit/Session/${obj.id}`);
      }
    } else if (location.pathname.includes("CourseConfig")) {
      props.selectClassOpen(obj, languages);
    }
  };

  const changeLanguage = (id, ind) => {
    setDropDownId(ind);
    let index = findIndex(product, { id: id });
    dispatch(productSliceActions.setLanguage(index));
    setModule(product[index]["data"]);
  };

  // JSX template
  return (
    <>
      <Grid>
        <Grid item xs={12}>
          <Grid item xs={12} className="">
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className={location.pathname.includes("Teach") ? "pl-3" : "pl-1"}
              sx={{ marginTop: "2em" }}
            >
              <Grid
                sx={{
                  color: "primary.main",
                  pl: location.pathname.includes("Teach") ? 2 : 0,
                  fontWeight: "500",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "500",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.6rem",
                    },
                  }}
                >
                  {/* {productName} */}
                  {/* {location.pathname.includes("Teach") && (
                    <IconButton
                      aria-label="search"
                      size="medium"
                      sx={{ ml: 2, color: "primary.main" }}
                      onClick={() => {
                        navigation("/Teach/TeachTreeView");
                      }}
                    >
                      <SearchIcon fontSize="inherit" />
                    </IconButton>
                  )} */}
                </Typography>
              </Grid>
              {languages && languages.length > 0 && (
                <Grid>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container direction="row" spacing={1}>
                      <Grid className="pr-1">
                        <FormControl sx={{ m: 1 }} fullWidth size="small">
                          <InputLabel id="demo-multiple-name-label">
                            Select Language
                          </InputLabel>
                          <Select
                            placeholder="Select an option"
                            value={dropDownId}
                            input={<OutlinedInput label="Select an option" />}
                            sx={{
                              borderRadius: 20,
                              borderColor: "#DB8829",
                              color: "#DB8829",
                              fontWeight: "500",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                                mt: 0.5,
                              },
                            }}
                          >
                            {languages.map((itemData, index) => (
                              <MenuItem
                                sx={{
                                  color: "#DB8829",
                                  fontSize: "0.8rem",
                                  fontWeight: "500",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.2rem",
                                  },
                                }}
                                key={`${index}_Class`}
                                value={index}
                                onClick={() => {
                                  changeLanguage(itemData.id, index);
                                }}
                              >
                                {itemData.value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: location.pathname.includes("Teach") ? 3 : 2,
              justifyContent: "flex-start",
              pl: location.pathname.includes("Teach") ? 11 : 0,
              pb: 2,
            }}
          >
            {!isLoading &&
              module
                .filter((val) => {
                  return (
                    coursePermissions &&
                    coursePermissions.indexOf(val.value) == -1
                  );
                })
                .map((obj, index) => {
                  return (
                    <div key={index}>
                      <ModuleCard
                        title={twoDigit(index + 1)}
                        subheading={obj.value}
                        caption={"Sessions: " + obj.data.length}
                        index={index}
                        press={() => redirect(obj)}
                        greenTick={
                          props.alreadySelected &&
                          props.alreadySelected.indexOf(obj.id) > -1
                            ? true
                            : false
                        }
                      />
                    </div>
                  );
                })}
          </Grid>
        </Grid>
      </Grid>
      {/* <Confirmation
        visible={alertFlag}
        primaryText={"Sessions not available"}
        image="error"
        alert={true}
        toggleModal={(flag) => setAlertFlag(flag)}
        timeout={2000}
      ></Confirmation> */}
    </>
  );
};

// Styles

export default Root;
